import { Component } from "react";
import View from "./view";
import "./index.css";

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return View.call(this);
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/dialog/index.js